import { useState } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

const UserIconMenu = () => {
  const router = useRouter();
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (menuKey) => {
    if (menuKey === 'logout') {
      handleClose();
      router.push('/logout');
    }
  };

  return (
    <>
      <IconButton aria-label="profile" style={{ color: '#fff' }} onClick={handleClick}>
        <AccountCircleIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => handleSelect('logout')}
        >
          {t('web/appbar.link.logout')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserIconMenu;
